import axios from "axios";
import {store} from "./configureStore";
import * as userActions from "./actions/user";
import AxiosConfig from "./AxiosConfig";

axios.defaults.withCredentials = true
axios.interceptors.response.use(
  null,
  function (error) {
    if (error.response.status === 401) {
      AxiosConfig.setAuthToken(null);
      store.dispatch(userActions.logout());
      // Snackbar.show({
      //   showAction: false,
      //   text:"Your session has expired. Please log in again",
      // });
    }
    return Promise.reject(error);
  }
);

export default axios;
